module.exports = __webpack_public_path__ + "static/media/cd-wolfgang.f3454e6c.jpg";